import LoadDetails from "./LoadDetails.jsx";

export default LoadDetails;
